import { defineStore } from 'pinia';
import { storage } from '../utils/storage';
import { messages } from '../i18n/messages';

const DEFAULT_LOCALE = 'zh-CN';

function resolvePath(target, path) {
  return path.split('.').reduce((current, segment) => current?.[segment], target);
}

function interpolate(message, params = {}) {
  if (typeof message !== 'string') {
    return message;
  }

  return Object.entries(params).reduce((output, [key, value]) => {
    return output.replaceAll(`{${key}}`, String(value));
  }, message);
}

export const useI18nStore = defineStore('i18n', {
  state: () => ({
    locale: storage.get('locale', DEFAULT_LOCALE),
  }),

  getters: {
    currentMessages: (state) => messages[state.locale] || messages[DEFAULT_LOCALE],
    isChinese: (state) => state.locale === 'zh-CN',
    altLocale: (state) => (state.locale === 'zh-CN' ? 'en-US' : 'zh-CN'),
  },

  actions: {
    setLocale(locale) {
      if (!messages[locale]) {
        return;
      }

      this.locale = locale;
      storage.set('locale', locale);
      document.documentElement.lang = locale;
    },

    toggleLocale() {
      this.setLocale(this.altLocale);
    },

    t(path, params = {}) {
      const direct = resolvePath(this.currentMessages, path);
      const fallback = resolvePath(messages[DEFAULT_LOCALE], path);
      const value = direct ?? fallback ?? path;
      return interpolate(value, params);
    },

    tm(path) {
      return resolvePath(this.currentMessages, path) ?? resolvePath(messages[DEFAULT_LOCALE], path);
    },
  },
});

